var exports = {
  "sectorWithSticky": "xfd349460--7d8541--sectorWithSticky",
};

module.exports = exports;
